import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
// 🌍 Liste enrichie de destinations avec toutes les infos
const coordinatesList = [
  {
    rect: "-10.0,4.0,-2.0,11.0",
    country: "Côte d'Ivoire",
    code: "CI",
    continent: "Afrique",
    capital: "Yamoussoukro",
    population: "26 M",
    currency: "Franc CFA",
    language: "Français",
    fallbackImage: "https://cdn.pixabay.com/photo/2017/03/28/12/10/elephant-2187080_960_720.jpg",
  },
  {
    rect: "-74.0,40.0,-73.0,41.0",
    country: "États-Unis",
    code: "US",
    continent: "Amérique",
    capital: "Washington D.C.",
    population: "331 M",
    currency: "Dollar US",
    language: "Anglais",
    fallbackImage: "https://cdn.pixabay.com/photo/2016/11/29/09/08/new-york-1867569_960_720.jpg",
  },
  {
    rect: "2.0,48.0,3.0,49.0",
    country: "France",
    code: "FR",
    continent: "Europe",
    capital: "Paris",
    population: "67 M",
    currency: "Euro",
    language: "Français",
    fallbackImage: "https://cdn.pixabay.com/photo/2015/03/26/09/54/eiffel-tower-690293_960_720.jpg",
  },
  {
    rect: "100.0,-10.0,101.0,-9.0",
    country: "Indonésie",
    code: "ID",
    continent: "Asie",
    capital: "Jakarta",
    population: "273 M",
    currency: "Roupie indonésienne",
    language: "Indonésien",
    fallbackImage: "https://cdn.pixabay.com/photo/2017/01/20/00/30/indonesia-1997689_960_720.jpg",
  },
  {
    rect: "139.0,35.0,140.0,36.0",
    country: "Japon",
    code: "JP",
    continent: "Asie",
    capital: "Tokyo",
    population: "125 M",
    currency: "Yen",
    language: "Japonais",
    fallbackImage: "https://cdn.pixabay.com/photo/2017/01/20/00/30/japan-1997685_960_720.jpg",
  },
  {
    rect: "12.0,41.0,13.0,42.0",
    country: "Italie",
    code: "IT",
    continent: "Europe",
    capital: "Rome",
    population: "59 M",
    currency: "Euro",
    language: "Italien",
    fallbackImage: "https://cdn.pixabay.com/photo/2016/01/19/17/52/colosseum-1148756_960_720.jpg",
  },
  {
    rect: "-3.8,40.3,-3.6,40.5",
    country: "Espagne",
    code: "ES",
    continent: "Europe",
    capital: "Madrid",
    population: "47 M",
    currency: "Euro",
    language: "Espagnol",
    fallbackImage: "https://cdn.pixabay.com/photo/2016/01/19/17/52/madrid-1148755_960_720.jpg",
  },
  {
    rect: "151.0,-34.0,152.0,-33.0",
    country: "Australie",
    code: "AU",
    continent: "Océanie",
    capital: "Canberra",
    population: "26 M",
    currency: "Dollar australien",
    language: "Anglais",
    fallbackImage: "https://cdn.pixabay.com/photo/2016/11/29/05/08/sydney-1868534_960_720.jpg",
  },
  {
    rect: "-58.5,-34.7,-58.3,-34.5",
    country: "Argentine",
    code: "AR",
    continent: "Amérique",
    capital: "Buenos Aires",
    population: "45 M",
    currency: "Peso argentin",
    language: "Espagnol",
    fallbackImage: "https://cdn.pixabay.com/photo/2016/11/29/09/08/buenos-aires-1867567_960_720.jpg",
  },
  {
    rect: "37.5,-1.3,37.7,-1.1",
    country: "Kenya",
    code: "KE",
    continent: "Afrique",
    capital: "Nairobi",
    population: "53 M",
    currency: "Shilling kényan",
    language: "Swahili, Anglais",
    fallbackImage: "https://cdn.pixabay.com/photo/2017/01/20/00/30/safari-1997690_960_720.jpg",
  },
  {
    rect: "31.2,30.0,31.4,30.2",
    country: "Égypte",
    code: "EG",
    continent: "Afrique",
    capital: "Le Caire",
    population: "104 M",
    currency: "Livre égyptienne",
    language: "Arabe",
    fallbackImage: "https://cdn.pixabay.com/photo/2016/11/29/09/08/egypt-1867568_960_720.jpg",
  },
  {
    rect: "55.2,25.1,55.4,25.3",
    country: "Émirats Arabes Unis",
    code: "AE",
    continent: "Asie",
    capital: "Abou Dabi",
    population: "9.9 M",
    currency: "Dirham",
    language: "Arabe",
    fallbackImage: "https://cdn.pixabay.com/photo/2016/11/29/09/08/dubai-1867566_960_720.jpg",
  },
  {
    rect: "-46.7,-23.7,-46.5,-23.5",
    country: "Brésil",
    code: "BR",
    continent: "Amérique",
    capital: "Brasília",
    population: "213 M",
    currency: "Réal brésilien",
    language: "Portugais",
    fallbackImage: "https://cdn.pixabay.com/photo/2016/11/29/09/08/rio-1867565_960_720.jpg",
  },
  {
    rect: "28.6,77.1,28.7,77.3",
    country: "Inde",
    code: "IN",
    continent: "Asie",
    capital: "New Delhi",
    population: "1,4 Md",
    currency: "Roupie indienne",
    language: "Hindi, Anglais",
    fallbackImage: "https://cdn.pixabay.com/photo/2016/11/29/09/08/india-1867564_960_720.jpg",
  },
  {
    rect: "30.0,59.9,30.4,60.1",
    country: "Russie",
    code: "RU",
    continent: "Europe/Asie",
    capital: "Moscou",
    population: "144 M",
    currency: "Rouble",
    language: "Russe",
    fallbackImage: "https://cdn.pixabay.com/photo/2016/11/29/09/08/moscow-1867563_960_720.jpg",
  },
];
export default function PopularDestinations() {
  const [places, setPlaces] = useState([]);
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [reloading, setReloading] = useState(false);
  // Charger les lieux
  const fetchPlaces = async () => {
    setReloading(true);
    const randomIndex = Math.floor(Math.random() * coordinatesList.length);
    const selected = coordinatesList[randomIndex];
    try {
      const res = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/external_apis/proxy.php?type=geoapify&categories=tourism.attraction&rect=${selected.rect}&limit=6`
      );
      
      // Vérifier le Content-Type avant de parser
      const contentType = res.headers.get('content-type');
      if (!contentType || !contentType.includes('application/json')) {
        console.error('❌ Le proxy ne retourne pas du JSON. Vérifiez que proxy.php est bien déployé.');
        const text = await res.text();
        console.error('Réponse reçue:', text.substring(0, 200));
        throw new Error('Le proxy API n\'est pas correctement configuré');
      }
      
      if (!res.ok) throw new Error(`Erreur HTTP : ${res.status}`);
      const data = await res.json();
      
      if (data.error) {
        console.error('❌ Erreur API:', data.error);
        throw new Error(data.error);
      }
      
      setPlaces(data.features?.map((p) => ({ ...p, countryInfo: selected })) || []);
    } catch (error) {
      console.error("Erreur chargement destinations :", error);
      setPlaces([]);
    } finally {
      setLoading(false);
      setTimeout(() => setReloading(false), 1000);
    }
  };
  // Charger images Pixabay (aléatoires, sinon fallback)
  const fetchPixabayImage = async (query, fallback) => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/external_apis/proxy.php?type=pixabay&q=${encodeURIComponent(query)}&per_page=6`
      );
      
      // Vérifier le Content-Type
      const contentType = res.headers.get('content-type');
      if (!contentType || !contentType.includes('application/json')) {
        console.warn('⚠️ Proxy Pixabay ne retourne pas du JSON, utilisation du fallback');
        return fallback;
      }
      
      const data = await res.json();
      if (data.hits?.length > 0) {
        const random = Math.floor(Math.random() * data.hits.length);
        return data.hits[random].webformatURL;
      }
      return fallback;
    } catch (error) {
      console.error("Erreur Pixabay:", error);
      return fallback;
    }
  };
  useEffect(() => {
    if (places.length > 0) {
      Promise.all(
        places.map((place) =>
          fetchPixabayImage(
            `${place.properties.city || place.countryInfo.country} ${place.countryInfo.country}`,
            place.countryInfo.fallbackImage
          )
        )
      ).then((results) => setImages(results));
    }
  }, [places]);
  useEffect(() => {
    fetchPlaces();
  }, []);
  return (
    <section className="py-20 bg-gradient-to-b from-blue-50 via-white to-yellow-50">
      <h2 className="text-5xl font-extrabold text-center mb-6 text-blue-800 drop-shadow-lg">
        🌍 Évasions populaires
      </h2>
      <p className="text-center text-lg text-gray-600 mb-14">
        Découvrez des lieux magiques autour du monde et laissez-vous inspirer 🌴
      </p>
      {loading ? (
        <p className="text-center text-gray-500 animate-pulse text-xl">
          ✨ Préparez vos valises... chargement en cours
        </p>
      ) : places.length === 0 ? (
        <p className="text-center text-red-500 text-xl">
          Aucune destination trouvée 😢
        </p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 container mx-auto px-6">
          {places.map((place, index) => {
            const name = place.properties.name || "Attraction touristique";
            const city =
              place.properties.city || place.properties.county || "Lieu connu";
            const countryInfo = place.countryInfo;
            const image = images[index] || countryInfo.fallbackImage;
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 40 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.2 }}
                className="bg-white rounded-3xl shadow-xl overflow-hidden hover:shadow-2xl transition transform hover:-translate-y-2 hover:scale-105"
              >
                <img src={image} alt={name} className="w-full h-56 object-cover" />
                <div className="p-6">
                  <h3 className="text-2xl font-bold text-blue-700 mb-2">{name}</h3>
                  <p className="text-gray-600 flex items-center gap-2 text-lg">
                    📍 {city}
                  </p>
                  {countryInfo && (
                    <div className="mt-3 text-sm text-gray-700 space-y-1">
                      <p className="flex items-center gap-2">
                        <img
                          src={`https://flagcdn.com/w20/${countryInfo.code.toLowerCase()}.png`}
                          alt={countryInfo.country}
                          className="w-6 h-4 rounded shadow"
                        />
                        <span className="font-medium">{countryInfo.country}</span>
                      </p>
                      <p>🌍 Continent : {countryInfo.continent}</p>
                      <p>🏙 Capitale : {countryInfo.capital}</p>
                      <p>👥 Population : {countryInfo.population}</p>
                      <p>💰 Monnaie : {countryInfo.currency}</p>
                      <p>🗣 Langue : {countryInfo.language}</p>
                    </div>
                  )}
                  <span className="mt-4 inline-block bg-gradient-to-r from-yellow-400 to-orange-500 text-white px-5 py-2 rounded-full text-sm font-medium shadow-md">
                    {place.properties.categories?.[0] || "Tourisme"}
                  </span>
                </div>
              </motion.div>
            );
          })}
        </div>
      )}
      <div className="text-center mt-10">
        <button
          onClick={fetchPlaces}
          className={`inline-flex items-center justify-center px-6 py-2 text-white font-semibold rounded-lg transition-all duration-300 ${
            reloading ? "bg-gray-400 cursor-not-allowed" : "bg-blue-500 hover:bg-blue-700"
          }`}
          disabled={reloading}
        >
          {reloading ? (
            <motion.div
              animate={{ rotate: 360 }}
              transition={{ duration: 1, repeat: Infinity }}
              className="mr-2"
            >
              <svg
                className="w-5 h-5 animate-spin"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <circle className="opacity-25" cx="12" cy="12" r="10" strokeWidth="4" />
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 1116 0A8 8 0 014 12z"
                />
              </svg>
            </motion.div>
          ) : (
            "Charger d'autres destinations"
          )}
        </button>
      </div>
    </section>
  );
}